export const ModoExibicaoDocumentos = [
  { value: 0, label: "Vaga" },
  { value: 1, label: "Cpf" },
  { value: 1, label: "Site" }
];


export const StatusDocuments = [
  { id: 2, name: "Reenviar" },
  { id: 3, name: "Aprovado" },
  { id: 4, name: "Descartar"}
];

export const TipoContrato =[

  { id: 0, name: "Aprendiz Adm" },
  { id: 1, name: "Aprendiz Teleservico" },
  { id: 2, name: "Estagiãrio" },
  { id: 3, name: "Atendentes" },
  { id: 4, name: "Administrativo" },
  { id: 5, name: "Administrativo - Gestores" },
  { id: 6, name: "Administrativo - Isento de ponto" },
  { id: 7, name: "Sem fronteira" }

];


export const StatusEtapaContratos = [
  { value: 0, label: "Aguardando assinatura" },
  { value: 1, label: "Em análise" },
  { value: 3, label: "Aprovado" },
  { value: 4, label: "Dispensado" },
  { value: 10, label: "Pendente de liberação" },
  { value: 17, label: "Divergência" },
  { value: 18, label: "Desistência" }

];

  //{ value: 16, label: "Contrato assinado" },
export const StatusEtapaDocumentos = [
  { value: 0, label: "Não enviado" },
  { value: 1, label: "Em análise" },
  { value: 3, label: "Aprovado" },
  { value: 18, label: "Desistência" },
  { value: 10, label: "Acesso Não Liberado" },
  { value: 22, label: "Pendente de reenvio"},
];

export const StatusMotivoDoContato = [
  { value: 0, label: "Erro Sistemico" },
  { value: 1, label: "Duvida Processo Seletivo" },
  { value: 2, label: "Reclamação Processo seletivo" },
  { value: 3, label: "Outros" },

];
export const StatusDuvidaContato = [
  { value: 0, label: "Aguardado" },
  { value: 1, label: "Não enviado" },
  { value: 2, label: "Respondido" },
  { value: 3, label: "visualizado" },

];

export const TipoVagaSelecao = [
  { value: 0, label: "Interna" },
  { value: 1, label: "Externa" }
];
export const TypesIndicator = [
  { id: 0, nome: "Por mês" },
  { id: 1, nome: "Por dia" }
];
